/* unplugin-vue-components disabled */import script from "./gaugeCard.vue?vue&type=script&setup=true&lang=js"
export * from "./gaugeCard.vue?vue&type=script&setup=true&lang=js"

import "./gaugeCard.vue?vue&type=style&index=0&id=5a0fa37c&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a0fa37c"]])

export default __exports__